import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { Provider } from "react-redux";
import { store, persistor } from "./configStore"
import { ConnectedRouter } from 'connected-react-router'
import history from "./history"
import { MuiThemeProvider } from '@material-ui/core';
import { mainTheme } from './styles/themes';

import { PersistGate } from 'redux-persist/integration/react';
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import Error from './components/Error'
import App from './App';

ReactDOM.render(
<Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <MuiThemeProvider theme={mainTheme}>
                <ConnectedRouter history={history}>
                    <div>
                        <Error/>
                        <App/>
                    </div>
                </ConnectedRouter>
            </MuiThemeProvider>
        </MuiPickersUtilsProvider>
    </PersistGate>
</Provider>
, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
